import React from 'react';
import { LoadingIndicator } from 'lib/components';
import { Flex } from 'lib/components/styles/layout';
import {
  EmptySearchText,
  EmptySearchWrapper,
} from 'app/pages/admin/landing-pages-v2/styles';
import { PaginationConstants } from 'lib/const/PaginationConstants';
import { Button } from 'react-covideo-common';
import { MdAdd } from 'react-icons/md';
import { useTheme } from 'styled-components/macro';
import { PronunciationTable } from './PronunciationTable';
import { IPronunciation } from 'lib/api/pronunciations/useQueryPronunciations';
import { PRONUNCIATIONS_SORT_KEYS } from '../constants';
import { useTranslation } from 'react-i18next';

interface IPronunciationListProps {
  data: IPronunciation[];
  isLoadingPronunciations?: boolean;
  count: number;
  page: number;
  size: number;
  order: PaginationConstants;
  sortKey: PRONUNCIATIONS_SORT_KEYS | null;
  onPaginationChange: (args: { page: number; size: number }) => void;
  onSortingUpdate: (sortKey: string, order: PaginationConstants) => void;
  handleCreateClick: () => void;
}

export const PronunciationList = ({
  data,
  isLoadingPronunciations,
  count,
  page,
  size,
  order,
  sortKey,
  onPaginationChange,
  onSortingUpdate,
  handleCreateClick,
}: IPronunciationListProps) => {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <Flex
      width='100%'
      flexDirection='row'
      gap='27px'
      justifyContent='flex-start'
      flexWrap='wrap'
    >
      {isLoadingPronunciations ? (
        <Flex width='100%' justifyContent='center'>
          <LoadingIndicator isLoading={true} />
        </Flex>
      ) : (
        <>
          {data && data.length > 0 ? (
            <PronunciationTable
              count={count}
              data={data}
              page={page}
              size={size}
              sortKey={sortKey}
              order={order}
              onPaginationChange={onPaginationChange}
              onSortingUpdate={onSortingUpdate}
            />
          ) : (
            <EmptySearchWrapper>
              <EmptySearchText maxWidth='677px' fontSize='16px'>
                {t(
                  'No pronunciation added yet. Add one to help AI pronounce names correctly.'
                )}
              </EmptySearchText>
              <Button
                text={t('Add Pronunciation')}
                icon={<MdAdd color={theme.colors.white[100]} />}
                onClick={handleCreateClick}
              />
            </EmptySearchWrapper>
          )}
        </>
      )}
    </Flex>
  );
};
